import HttpService from "@/services/HttpService"

const MailService = {
    async sendMailInfOferta(nombre, agencia, id, message, email){
        return await HttpService.post("/operadora/sendMailOffer", {
            nombre: nombre,
            agencia: agencia,
            id: id,
            message: message,
            email: email
        })
    },
    async sendMailVisa(nombre, email, telefono, nacionalidad, residencia, origen, destino, pasaporte, salida, retorno){
        return await HttpService.post('/operadora/sendMailVisa',{
            nombre: nombre,
            email: email,
            telefono: telefono,
            nacionalidad: nacionalidad,
            residencia: residencia,
            origen:origen,
            destino: destino,
            pasaporte: pasaporte,
            salida: salida,
            retorno: retorno
        })
    }
}

export default MailService